import React from "react";
import { SiteController } from "./SiteController";
import { SiteViewModel } from "./SiteViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class SiteProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new SiteViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <SiteController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sites/SiteProvider.js